<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div class="matrix_quantityFieldLabel">
      {{ $t(name) }}
    </div>
    <input
      v-model="quantity"
      type="number"
      onkeydown="return event.keyCode !== 69"
      @keydown.enter="onQuantity"
      @blur="onQuantity"
    />
  </div>
</template>
<script>
import { useQuantityFieldStore } from "@/stores/modules/quantityField";
import { mapState, mapActions } from "pinia";
import { useWebproductStore } from "@/stores/modules/webproduct";

import { i18n } from "../../i18n.js";

export default {
  computed: {
    ...mapState(useQuantityFieldStore, ["getQuantityField"]),
    ...mapState(useWebproductStore, ["getSweetAlert"]),
    name: () => {
      return "Quantity:";
    },
    quantity: {
      get: function () {
        return this.getQuantityField;
      },
      set: function (newValue) {
        this.setQuantityField(newValue);
      }
    }
  },
  methods: {
    ...mapActions(useQuantityFieldStore, ["setQuantityField"]),
    onQuantity: function (event) {
      event.preventDefault();
      var isNum = /^\d+$/.test(event.target.value);
      if (!isNum) {
        this.getSweetAlert({
          text: i18n.t("Please enter a valid number !"),
          icon: "warning"
        });
        this.quantity = 1;
        return;
      }

      var intQty = parseInt(event.target.value);

      if (intQty == 0) {
        this.getSweetAlert({
          text: i18n.t("Quantity should be bigger than 0"),
          icon: "warning"
        });
        this.quantity = 1;
        return;
      }
    }
  }
};
</script>
